import React from 'react';
import styled from 'styled-components';

import { ReactComponent as BookIcon } from '@/assets/svg/book.svg';

type Props = {
  withIcon?: boolean;
  text: string;
  className?: string;
};

const TextWithIcon = ({ withIcon, text, className }: Props) => {
  if (withIcon) {
    return (
      <Component>
        <StyledBookIcon />
        <Text className={className}>{text}</Text>
      </Component>
    );
  }
  return <Text className={className}>{text}</Text>;
};

export default TextWithIcon;

const Component = styled.div`
  position: relative;
  padding-left: 26px;
`;

const Text = styled.span`
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 30px;
`;
const StyledBookIcon = styled(BookIcon)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
`;
